export const portalName = process.env.REACT_APP_PORTAL_NAME;
export const emailPrefix = process.env.REACT_APP_EMAIL_PREFIX;
export const appMode = process.env.REACT_APP_APP_MODE;
